import React, { useState, useRef, useEffect } from "react";
import { useLang } from "@/context/LangContext";
import { Languages, ChevronDown } from "lucide-react";

const LANGS = [
  { code: "sk", flag: "🇸🇰", label: "Slovenčina" },
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "cs", flag: "🇨🇿", label: "Čeština" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
  { code: "pl", flag: "🇵🇱", label: "Polski" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
];

export default function LangSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="lang-toggle"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 px-2 py-1 text-xs font-mono uppercase border border-zinc-700 hover:border-gold-600 text-zinc-300 hover:text-white transition-colors"
      >
        <Languages className="w-3 h-3" /> <span>{cur.flag} {cur.code.toUpperCase()}</span>
        <ChevronDown className="w-3 h-3 opacity-60" />
      </button>
      {open && (
        <div data-testid="lang-dropdown" className="absolute right-0 mt-1 w-48 bg-[var(--wb-bg)] border border-gold-700/40 shadow-xl z-50">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 ${lang === l.code ? "bg-gold-500/20 text-white" : "text-zinc-300 hover:bg-zinc-800"}`}
            >
              <span className="text-base">{l.flag}</span>
              <span className="flex-1">{l.label}</span>
              <span className="text-[10px] font-mono uppercase opacity-60">{l.code}</span>
            </button>
          ))}
          <div className="px-3 py-1.5 text-[10px] font-mono text-zinc-600 border-t border-zinc-800">
            Some non-SK/EN translations fall back to EN.
          </div>
        </div>
      )}
    </div>
  );
}
